const sharedMobileDesktop = require('../pages/content/privacy_'+language+'.js');

export default {
  large: [
    {
      name: 'Privacy &<br>integrity policy',

      fixedSection: {
        sectionType: 'toc',
        data: {
          headline: sharedMobileDesktop.headline,
          index: sharedMobileDesktop.index,
          paging: false,
          numbered: true,
        },
      },

      sharedData: {
        currentSubSection: 0,
        scrollingPosition: null,
      },

      scrolledSection: {
        sectionType: 'text-block',
        data: {
          texts: [
            {
              headline: sharedMobileDesktop.headline,
              html: sharedMobileDesktop.terms,
            },
          ]
        }
      },
    }
  ],
};



// WEBPACK FOOTER //
// ./pages/Privacy.js